// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"501ce604","508":"85e4bb9b","643":"a4b490d2","737":"b34074fc","752":"f88ba029","817":"1a6bb0e4","907":"d908b8d1","916":"87fe4d9c"}[chunkId] + ".chunk.js";
};